// React
import { FunctionComponent } from "react"

// Interfaces and constants
import { I_SafetyEvent } from "src/pages/vehicle_incidents/interfaces"
import vehicleIncidentsTableItems from "src/pages/vehicle_incidents/constants/VehicleIncidentsTableItems"

// Components
import { hoverRevealHostClass } from "src/components/common/HoverRevealActions"
import VehicleIncidentsTableBodyTD from "./VehicleIncidentsTableBodyTD/VehicleIncidentsTableBodyTD"

interface Props {
    i: number
    rowActive: boolean
    eventItem: I_SafetyEvent
    handleLinkClick: (id: number) => void
    clickedLinks: Set<number>
    loader: number
}

// Renders a single <tr> element for the vehicle incidents table
const VehicleIncidentsTableBodyTR: FunctionComponent<Props> = (props) => {

    const {
        i,
        rowActive,
        eventItem,
        handleLinkClick,
        clickedLinks,
        loader
    } = props

    return (
        <tr
            key={i}
            id={`vitb-tr-${eventItem.ID}`}
            className={`VehicleIncidentsTableBodyTR ${hoverRevealHostClass} ${rowActive ? "VehicleIncidentsTableBodyTRActive" : ""}`}
        >
            {vehicleIncidentsTableItems.map((tblItem, j) => (
                <VehicleIncidentsTableBodyTD
                    key={`${eventItem.ID}-${tblItem.key}-${i}-${j}`}
                    tblItem={tblItem}
                    eventItem={eventItem}
                    i={i}
                    j={j}
                    handleLinkClick={handleLinkClick}
                    clickedLinks={clickedLinks}
                    loader={loader}
                />
            ))}
        </tr>
    )
}

export default VehicleIncidentsTableBodyTR